import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import View from './View';

const Edit = ({
  content,
  partial,
}: {
  content: Content;
  partial?: boolean;
}) => {
  const formData = useSelector(
    (state: { form: { global: Content } }) => state.form.global,
  );
  if (formData && Object.keys(formData).length > 0) {
    content = formData;
  }
  return <View isEdit isViewOrEdit content={content} partial={partial} />;
};

export default Edit;
